import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Card, Button, Row, Col, Modal } from "react-bootstrap";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getTutorialSteps, createRestaurant } from "../actions/restaurantActions";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowRight, faCircleArrowLeft, faPlus, faXmark, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import TutorialSteps from "../components/TutorialSteps";
import AutoFillAddress from "../components/AutoFillAddress";
import FiscalAdress from "./FiscalAdress";
import DropDownButton from "../components/DropDownButton";
import StripePay from "../components/StripePay";
import PhoneField from "../components/PhoneField";
/* global google */
import { ErrorMessageBox, CloseIcon, ConfirmationModal, ModalOverlay, ModernButton } from "../components/DefaultImports";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
const TutorialBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 505px;
  position: relative;
  min-height: 600px;
  overflow: hidden;
`;
const TutorialBoxContent = styled.div`
  width: 100%;
  padding: 1.5rem;
  overflow-y: auto;
  margin-top: -15px;
`;
const TutorialBoxText = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
  color: #222;
  text-align: center;
  width: 100%;
  margin-bottom: 40px;
  border-bottom: 2px solid #ee561b;
  padding-bottom: 10px;
`;
const TutorialBoxMiddleSteps = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.9rem;
  color: #999;
  font-weight: 500;
  letter-spacing: 0.4px;
`;
const StyledInput = styled.input`
  width: 100%;
  padding: 14px 18px;
  margin-bottom: ${props => props.invalid ? "6px" : "24px"};
  font-size: 16px;
  border: 1px solid ${props => props.invalid ? "#dc3545" : "#ddd"};
  border-radius: 10px;
  background-color: #fafafa;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${props => props.invalid ? "#dc3545" : "#de8c3a"};
    background-color: #fff;
    box-shadow: ${props => props.invalid ? "0 0 0 4px rgba(220, 53, 69, 0.15)" : "0 0 0 4px rgba(222, 140, 58, 0.15)"};
    outline: none;
  }

  &::placeholder {
    color: #aaa;
  }
`;
const FieldError = styled.div`
  width: 100%;
  color: #dc3545;
  font-size: 0.82rem;
  font-weight: 600;
  text-align: left;
  margin-top: -2px;
  margin-bottom: 16px;
  line-height: 1.25;
`;
const StepErrorBox = styled.div`
  width: 100%;
  color: #dc3545;
  background: rgba(220, 53, 69, 0.08);
  border: 1px solid rgba(220, 53, 69, 0.25);
  border-radius: 8px;
  padding: 10px 12px;
  margin: 8px 0 18px 0;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
`;
const CreateButtom = styled.div`
  padding: 10px 15px;
  background-color: ${props => props.disabled ? "#99b0ad" : "#ee561b"};
  color: #faf6e9;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
  position: absolute;
  bottom: 5px;
  right: 12px;
  transition:
    background 0.3s ease,
    transform 0.2s;

  &:hover {
    background-color: ${props => props.disabled ? "#99b0ad" : "#cc7a2d"};
    transform: ${props => props.disabled ? "none" : "translateY(-2px)"};
  }
`;
const StyledArrowRight = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 5px;
  right: 24px;
  font-size: 2rem;
  color: #99b0ad;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
    color: #99b0ad;
  }
`;
const StyledArrowLeft = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 5px;
  left: 24px;
  font-size: 2rem;
  color: #99b0ad;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
    color: #99b0ad;
  }
`;
const StyledH5 = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
  margin-top: 0;
`;
const OptionalMapMessage = styled.div`
  width: 100%;
  margin-top: -8px;
  margin-bottom: 18px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(153, 176, 173, 0.12);
  color: #6a837f;
  font-size: 0.85rem;
  font-weight: 600;
`;
const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options?.timeZone || "";
  }
  return "";
};
function RestaurantCreation({
  setRestauranteCreationModal
}) {
  const {
    t
  } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addressInputRef = useRef("");
  const [currentStep, setCurrentStep] = useState("name");
  const [stepCounter, setStepCounter] = useState(1);
  const [showStepsModal, setShowStepsModal] = useState(params.tutorial === "yes");
  const [restaurantName, setRestaurantName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [locality, setLocality] = useState("");
  const [longitudeField, setLongitudeField] = useState(null);
  const [latitudeField, setLatitudeField] = useState(null);
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const [fiscalAdressId, setFiscalAdressId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [invalidFields, setInvalidFields] = useState([]);
  const [isCreateRestaurant, setIsCreateRestaurant] = useState(false);
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [showConfirmExit, setShowConfirmExit] = useState(false);
  const tutorial_steps_list = useSelector(state => state.tutorial_steps);
  const {
    tutorialSteps,
    isLoadingTutorialSteps,
    tutorialStepsError
  } = tutorial_steps_list;
  const userLogin = useSelector(state => state.userLogin);
  const {
    userInfo
  } = userLogin;
  const created_restaurant = useSelector(state => state.create_a_restaurant);
  const {
    createRestaurant: myCustomCreateRestaurant,
    isLoadingCreateRestaurant,
    error: createRestaurantError
  } = created_restaurant;
  const paymentIntentInfo = useSelector(state => state.paymentIntent);
  const {
    paymentIntent
  } = paymentIntentInfo;
  const {
    isLoaded: isGoogleLoaded,
    loadError: googleLoadError
  } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDtPooGWkj4z_ExlO9ggRMwwI9QiFZuZTI"
  });
  const [marker, setMarker] = useState(null);
  const [googleMapUnavailable, setGoogleMapUnavailable] = useState(false);
  useEffect(() => {
    dispatch(createRestaurant("", true));
  }, [dispatch]);
  useEffect(() => {
    dispatch(getTutorialSteps(currentStep));
  }, [dispatch, currentStep]);
  useEffect(() => {
    if (myCustomCreateRestaurant && isCreateRestaurant) {
      navigate(`/pick_plan_and_pay/${myCustomCreateRestaurant.id}`);
    }
  }, [myCustomCreateRestaurant, isCreateRestaurant, isLoadingCreateRestaurant, navigate]);
  useEffect(() => {
    if (createRestaurantError && isCreateRestaurant) {
      setShowError(true);
      setErrorMessage(typeof createRestaurantError === "string" ? createRestaurantError : "Erro ao criar restaurante. Verifica os dados e tenta novamente.");
    }
  }, [createRestaurantError, isCreateRestaurant]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      const query = [address, postalCode, locality, country].filter(Boolean).join(", ");
      if (!query) {
        setLatitudeField(null);
        setLongitudeField(null);
        setMarker(null);
        setGoogleMapUnavailable(false);
        return;
      }
      if (googleLoadError || !isGoogleLoaded || !window.google?.maps?.Geocoder) {
        console.warn("Google Maps não carregou. O restaurante pode ser criado sem coordenadas.");
        setLatitudeField(null);
        setLongitudeField(null);
        setMarker(null);
        setGoogleMapUnavailable(true);
        return;
      }
      try {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
          address: query
        }, (results, status) => {
          if (status === "OK" && results?.length > 0) {
            const location = results[0].geometry.location;
            const lat = location.lat();
            const lng = location.lng();
            setLatitudeField(lat);
            setLongitudeField(lng);
            setMarker({
              lat,
              lng
            });
            setGoogleMapUnavailable(false);
          } else {
            console.warn("Google geocode falhou:", status);

            // Important: Google failure should never block restaurant creation.
            setLatitudeField(null);
            setLongitudeField(null);
            setMarker(null);
            setGoogleMapUnavailable(true);
          }
        });
      } catch (error) {
        console.warn("Erro ao usar Google Maps:", error);

        // Important: Google failure should never block restaurant creation.
        setLatitudeField(null);
        setLongitudeField(null);
        setMarker(null);
        setGoogleMapUnavailable(true);
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [address, postalCode, locality, country, isGoogleLoaded, googleLoadError]);
  const onMapClick = React.useCallback(event => {
    if (!event?.latLng) return;
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setMarker({
      lat,
      lng
    });
    setLatitudeField(lat);
    setLongitudeField(lng);
    setGoogleMapUnavailable(false);
  }, []);
  const normalizeValue = value => String(value ?? "").trim();
  const hasPhoneStarted = () => {
    return normalizeValue(phoneWithoutCountryCode).length > 0;
  };
  const getFields = () => {
    return {
      restaurantName,
      isPhoneValid,
      phoneWithoutCountryCode,
      address,
      postalCode,
      locality,
      country,
      fiscalAdressId
    };
  };
  const validateRestaurantFields = (stepToValidate, fields) => {
    const errors = {};
    if (stepToValidate === "name") {
      if (!normalizeValue(fields.restaurantName)) {
        errors.restaurantName = "Escreve o nome do restaurante.";
      }
      if (hasPhoneStarted() && !fields.isPhoneValid) {
        errors.phone = "O número de telemóvel não parece válido.";
      }
    }
    if (stepToValidate === "adress") {
      if (!normalizeValue(fields.country)) {
        errors.country = "Escreve o país.";
      }
      if (!normalizeValue(fields.address)) {
        errors.address = "Escreve a morada.";
      }
      if (!normalizeValue(fields.postalCode)) {
        errors.postal_code = "Escreve o código postal.";
      }
      if (!normalizeValue(fields.locality)) {
        errors.locality = "Escreve a localidade.";
      }
    }
    if (stepToValidate === "fiscal_address") {
      if (!normalizeValue(fields.fiscalAdressId)) {
        errors.fiscalAdressId = "Seleciona ou cria um perfil fiscal.";
      }
    }
    return errors;
  };
  const validateAllRestaurantFields = () => {
    const fields = getFields();
    return {
      ...validateRestaurantFields("name", fields),
      ...validateRestaurantFields("adress", fields),
      ...validateRestaurantFields("fiscal_address", fields)
    };
  };
  const stepNumberByStepName = {
    name: 1,
    adress: 2,
    fiscal_address: 3
  };
  const getFirstStepWithErrors = errors => {
    const keys = Object.keys(errors);
    if (keys.includes("restaurantName") || keys.includes("phone")) {
      return "name";
    }
    if (keys.includes("country") || keys.includes("address") || keys.includes("postal_code") || keys.includes("locality")) {
      return "adress";
    }
    if (keys.includes("fiscalAdressId")) {
      return "fiscal_address";
    }
    return currentStep;
  };
  const applyValidationErrors = errors => {
    const keys = Object.keys(errors);
    setFieldErrors(errors);
    setInvalidFields(keys);
    if (keys.length > 0) {
      setShowError(true);
      setErrorMessage("Corrige os campos assinalados antes de continuar.");
      return false;
    }
    setShowError(false);
    setErrorMessage("");
    return true;
  };
  const clearFieldError = key => {
    if (!fieldErrors[key]) return;
    setFieldErrors(prev => {
      const next = {
        ...prev
      };
      delete next[key];
      return next;
    });
    setInvalidFields(prev => prev.filter(item => item !== key));
  };
  const validateCurrentStep = () => {
    const validationErrors = validateRestaurantFields(currentStep, getFields());
    return applyValidationErrors(validationErrors);
  };
  function checkForErrorsAndCreateRestaurant() {
    if (isLoadingCreateRestaurant) return;
    const allErrors = validateAllRestaurantFields();
    if (!applyValidationErrors(allErrors)) {
      const firstInvalidStep = getFirstStepWithErrors(allErrors);
      setCurrentStep(firstInvalidStep);
      setStepCounter(stepNumberByStepName[firstInvalidStep] || 1);
      return;
    }
    const updatedRestaurantParams = {
      restaurant_name: normalizeValue(restaurantName),
      phone_number: normalizeValue(phoneWithoutCountryCode),
      country_code: normalizeValue(countryCodeNumber),
      postal_code: normalizeValue(postalCode),
      locality: normalizeValue(locality),
      // Google Maps coordinates are optional.
      // If Google Maps/geocode fails, the restaurant is still created.
      latitude: typeof latitudeField === "number" && Number.isFinite(latitudeField) ? latitudeField : null,
      longitude: typeof longitudeField === "number" && Number.isFinite(longitudeField) ? longitudeField : null,
      adress: normalizeValue(address),
      country: normalizeValue(country),
      fiscal_information: fiscalAdressId,
      timezone: timezone
    };
    dispatch(createRestaurant(updatedRestaurantParams));
    setIsCreateRestaurant(true);
  }
  const handleNextSteps = () => {
    if (!validateCurrentStep()) return;
    setErrorMessage("");
    setShowError(false);
    const nextStepCounter = stepCounter + 1;
    setStepCounter(nextStepCounter);
    switch (nextStepCounter) {
      case 2:
        setCurrentStep("adress");
        break;
      case 3:
        setCurrentStep("fiscal_address");
        break;
      default:
        setCurrentStep("name");
    }
  };
  const handleGoBackSteps = () => {
    const previousStepCounter = stepCounter - 1;
    setStepCounter(previousStepCounter);
    setShowError(false);
    setErrorMessage("");
    switch (previousStepCounter) {
      case 1:
        setCurrentStep("name");
        break;
      case 2:
        setCurrentStep("adress");
        break;
      case 3:
        setCurrentStep("fiscal_address");
        break;
      default:
        setCurrentStep("name");
    }
  };
  const handleCloseStepsModal = () => setShowStepsModal(false);
  const renderFieldError = key => {
    if (!fieldErrors[key]) return null;
    return <FieldError>{fieldErrors[key]}</FieldError>;
  };
  const canShowGoogleMap = isGoogleLoaded && !googleLoadError && marker && typeof latitudeField === "number" && typeof longitudeField === "number";
  return <TutorialBox>
      <TutorialBoxContent>
        {showError && errorMessage && <StepErrorBox>
            <FontAwesomeIcon icon={faTriangleExclamation} /> {errorMessage}
          </StepErrorBox>}

        {currentStep === "name" && <>
            <StyledH5>{t("ui.screens.restaurantCreation.nome")}</StyledH5>
            <StyledInput type="text" value={restaurantName} placeholder={t("ui.screens.restaurantCreation.nomeDoRestaurante")} onChange={e => {
          setRestaurantName(e.target.value);
          clearFieldError("restaurantName");
        }} invalid={invalidFields.includes("restaurantName")} />
            {renderFieldError("restaurantName")}

            <StyledH5>{t("ui.screens.restaurantCreation.numeroDeTelemovelOpcional")}</StyledH5>
            <PhoneField countryCodeNumber={countryCodeNumber} setCountryCodeNumber={setCountryCodeNumber} phoneWithoutCountryCode={phoneWithoutCountryCode} setPhoneWithoutCountryCode={value => {
          setPhoneWithoutCountryCode(value);
          clearFieldError("phone");
        }} isPhoneValid={isPhoneValid} setIsPhoneValid={value => {
          setIsPhoneValid(value);
          if (value) clearFieldError("phone");
        }} />
            {renderFieldError("phone")}
          </>}

        {currentStep === "adress" && <>
            <StyledH5>{t("ui.screens.restaurantCreation.morada")}</StyledH5>

            <StyledInput type="text" value={country} onChange={e => {
          setCountry(e.target.value);
          clearFieldError("country");
        }} placeholder={t("ui.screens.restaurantCreation.pais")} invalid={invalidFields.includes("country")} />
            {renderFieldError("country")}

            <StyledInput type="text" ref={addressInputRef} value={address} onChange={e => {
          setAddress(e.target.value);
          clearFieldError("address");
        }} placeholder={t("ui.screens.restaurantCreation.morada2")} autoComplete="nope" invalid={invalidFields.includes("address")} />
            {renderFieldError("address")}

            <Row>
              <Col xs={5}>
                <StyledInput type="text" value={postalCode} onChange={e => {
              setPostalCode(e.target.value);
              clearFieldError("postal_code");
            }} placeholder={t("ui.screens.restaurantCreation.codigoPostal")} invalid={invalidFields.includes("postal_code")} />
                {renderFieldError("postal_code")}
              </Col>

              <Col xs={7}>
                <StyledInput type="text" value={locality} onChange={e => {
              setLocality(e.target.value);
              clearFieldError("locality");
            }} placeholder={t("ui.screens.restaurantCreation.localidade")} invalid={invalidFields.includes("locality")} />
                {renderFieldError("locality")}
              </Col>
            </Row>

            {canShowGoogleMap && <GoogleMap mapContainerStyle={{
          width: "100%",
          height: "350px"
        }} center={{
          lat: latitudeField,
          lng: longitudeField
        }} zoom={18} onClick={onMapClick} options={{
          streetViewControl: false
        }}>
                <Marker position={marker} draggable={true} onDragEnd={onMapClick} />
              </GoogleMap>}

            {googleMapUnavailable && <OptionalMapMessage>{t("ui.screens.restaurantCreation.naoFoiPossivelCarregarALocalizacao")}</OptionalMapMessage>}
          </>}

        {currentStep === "fiscal_address" && <>
            <StyledH5>{t("ui.screens.restaurantCreation.perfilFiscal")}</StyledH5>
            <FiscalAdress isItSelectable={true} currentSelected={fiscalAdressId} setSelected={value => {
          setFiscalAdressId(value);
          clearFieldError("fiscalAdressId");
        }} cardsPerRow={1} />
            {renderFieldError("fiscalAdressId")}
          </>}

        {currentStep === "payment" && <>
            <TutorialBoxText>{t("ui.screens.restaurantCreation.pagamento")}</TutorialBoxText>
            <StripePay restaurant_id={"1"} subscription_number={1} payment_method={"stripe"} />
          </>}

        {stepCounter > 1 && <StyledArrowLeft icon={faCircleArrowLeft} onClick={handleGoBackSteps} />}

        {stepCounter < 3 && <StyledArrowRight icon={faCircleArrowRight} onClick={handleNextSteps} />}

        {stepCounter === 3 && <CreateButtom disabled={isLoadingCreateRestaurant} onClick={checkForErrorsAndCreateRestaurant}>
            {isLoadingCreateRestaurant ? "A guardar..." : "Guardar"}
          </CreateButtom>}

        <TutorialBoxMiddleSteps>{t("ui.screens.restaurantCreation.passo")}{stepCounter} / 3</TutorialBoxMiddleSteps>

        <TutorialSteps showModal={showStepsModal} step={currentStep} setShowModalFalse={handleCloseStepsModal} />

        {showConfirmExit && <>
            <ModalOverlay />
            <ConfirmationModal show={showConfirmExit} onHide={() => setShowConfirmExit(false)} centered>
              <div className="modal-header">
                <h5 className="modal-title">{t("ui.screens.restaurantCreation.cancelarCriacao")}</h5>
                <CloseIcon icon={faXmark} onClick={() => setShowConfirmExit(false)} role="button" tabIndex="0" style={{
              color: "white"
            }} />
              </div>

              <div className="modal-body">{t("ui.screens.restaurantCreation.temCertezaQueDesejaSairAs")}</div>

              <div className="modal-footer">
                <ModernButton color="#99b0ad" fontSize="14px" onClick={() => setShowConfirmExit(false)}>{t("ui.screens.restaurantCreation.cancelar")}</ModernButton>

                <ModernButton color="#ff704d" fontSize="14px" onClick={() => setRestauranteCreationModal(false)}>{t("ui.screens.restaurantCreation.confirmar")}</ModernButton>
              </div>
            </ConfirmationModal>
          </>}
      </TutorialBoxContent>
    </TutorialBox>;
}
export default RestaurantCreation;
